import { Form, Input, notification } from 'antd';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import Heading from '../../../../components/heading/heading';
import { Api } from '../../../../config/api/axiosInterceptors';
import { login } from '../../../../redux/authUser/actions';
import logoBalken from '../../../../static/img/balken/balken_logo_BALKEN.png';
import Storage from '../../../../utils/storage';
import { generateRequiredRule } from '../../../../utils/validationRules';
import { AuthWrapper } from './style';
import { Button } from '../../../../components/buttons/buttons';

function SignIn() {
  const [form] = Form.useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const emailRules = [generateRequiredRule('correo electrónico')];
  const passwordRules = [generateRequiredRule('contraseña')];

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await Api.post('/login', data);
      const { token, user } = response.data;
      Storage.setItem('token', token);
      await dispatch(login(user));
      history.push(`${user.roles[0].name}`);
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message || 'Error al iniciar sesión',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthWrapper>
      <div className="auth-contents">
        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <img className="balken-logo" src={logoBalken} alt="" />
          <Heading as="h3">
            <strong className="heading-title">Inicio de sesión</strong>
            <p className="secondary-text">
              Bienvenido nuevamente, ingresa tu correo electrónico y contraseña para acceder al sitio.
            </p>
          </Heading>
          <Form.Item name="email" rules={emailRules} label="Correo electrónico">
            <Input />
          </Form.Item>
          <Form.Item name="password" rules={passwordRules} label="Contraseña">
            <Input.Password />
          </Form.Item>

          <Button block htmlType="submit" type="primary" size="large">
            {loading ? 'Cargando...' : 'Iniciar sesión'}
          </Button>

          <div className="action-link">
            <NavLink className="forgot-password-text" to="/recuperar-contrasena">
              ¿Olvidaste tu contraseña?
            </NavLink>
          </div>
        </Form>
      </div>
    </AuthWrapper>
  );
}

export default SignIn;
